import * as React from 'react';
import { ICAForm, CAForm, IUser, IEntityFormProps2, IOrgConfig } from '../../types';
import * as services from '../../services';
import styles from '../../styles/cr.module.scss';
import { FormButtons } from '.././cr/FormButtons';
import { ConfirmDialog } from '.././cr/ConfirmDialog';
import { UpdateHeader2 } from '../cr/UpdateHeader2';

export interface ISignOffFormProps extends IEntityFormProps2 {
    signoffFor: string;
    formId: number;
    form: ICAForm;
    title?: string;
    signoffText?: string;
    onSignOff: () => void;
    canSignOffDDSection: boolean;
    canSignOffDirSection: boolean;
    orbConfig: IOrgConfig;
}

export class SignOffFormState {
    public ShowForm = false;
    public ShowConfirmDialog = false;
    public DDSignOffName: string = null;
    public DirSignOffName: string = null;
}

export default class SignOffForm extends React.Component<ISignOffFormProps, SignOffFormState> {
    private formService: services.CAFormService = new services.CAFormService();
    private userService: services.UserService = new services.UserService();

    constructor(props: ISignOffFormProps, state: SignOffFormState) {
        super(props);
        this.state = new SignOffFormState();
    }

    public render(): React.ReactElement<ISignOffFormProps> {
        const { title, signoffText } = this.props;
        const { ShowForm } = this.state;

        return (
            <div className={styles.cr}>
                <UpdateHeader2 title={title} isOpen={ShowForm}
                    leadUser=""
                    rag={this.getRag()}
                    ragLabel={this.getRagLabel()}
                    onClick={this.toggleProgressUpdateForm} />

                {ShowForm && <div className={`ms-scaleDownIn100`}>
                    {this.renderFormFields(signoffText)}
                    <ConfirmDialog hidden={!this.state.ShowConfirmDialog} title="Sign-Off Confirmation" content="Are you sure you want to sign-off this form?" confirmButtonText="Sign-Off" handleConfirm={this.saveUpdate} handleCancel={() => this.setState({ ShowConfirmDialog: false })} />
                    <FormButtons
                        primaryText={this.props.signoffFor === "DD" ? `Sign off as ${this.props.orbConfig.OrgMgrL3Lable}` : `Sign off as ${this.props.orbConfig.OrgMgrL2Lable}`}
                        onPrimaryClick={this.displayConfirm}
                        primaryDisabled={!this.enableSignOff()}
                    />
                </div>}
            </div>
        );
    }

    private renderFormFields(signoffText?: string) {
        return (
            <div style={{ padding: '2px 15px' }}>
                {this.renderSignOffText(signoffText)}
            </div>
        );
    }
    private renderSignOffText(signoffText: string) {
        let signedOffBy = "";
        if (this.props.signoffFor === "DD") {
            if (this.state.DDSignOffName != null) {
                signedOffBy = `<br/><br/>Signed off by ${this.state.DDSignOffName} on ${services.DateService.dateToUkDate(this.props.form.DDSignOffDate)} at ${services.DateService.dateToUkTime(this.props.form.DDSignOffDate)}`;
            }
        }
        else {
            if (this.state.DirSignOffName != null) {
                signedOffBy = `<br/><br/>Signed off by ${this.state.DirSignOffName} on ${services.DateService.dateToUkDate(this.props.form.DirSignOffDate)} at ${services.DateService.dateToUkTime(this.props.form.DirSignOffDate)}`;
            }
        }
        if (signoffText != null && signoffText != "")
            return (
                <div style={{ marginTop: 10, marginBottom: 20 }} dangerouslySetInnerHTML={{ __html: signoffText + signedOffBy }}></div>
            );
    }

    private enableSignOff(): boolean {

        if (this.props.signoffFor === "DD") {
            if (this.props.form.LastSignOffFor === "WaitingSignOff") {
                //check if the user is logged in as DD
                if (this.props.canSignOffDDSection === true)
                    return true;
            }
        }
        else {
            if (this.props.form.LastSignOffFor === "DD") {
                //check if the user is logged in as D
                if (this.props.canSignOffDirSection === true)
                    return true;
            }
        }

        return false;
    }

    private getRagLabel(): string {
        if (this.props.signoffFor === "DD") {
            if (this.props.form.LastSignOffFor === "WaitingSignOff") {
                return "Require SignOff";
            }
            else if (this.props.form.DDSignOffStatus === true) {
                return "Signed Off";
            }
            else {
                return "N/A";
            }
        }
        else {
            if (this.props.form.LastSignOffFor === "DD") {
                return "Require SignOff";
            }
            else if (this.props.form.DirSignOffStatus === true) {
                return "Signed Off";
            }
            else {
                return "N/A";
            }
        }
    }

    private getRag(): number {
        if (this.props.signoffFor === "DD") {
            if (this.props.form.LastSignOffFor === "WaitingSignOff") {
                return 3;
            }
            else if (this.props.form.DDSignOffStatus === true) {
                return 5;
            }
            else {
                return null;
            }
        }
        else {
            if (this.props.form.LastSignOffFor === "DD") {
                return 3;
            }
            else if (this.props.form.DirSignOffStatus === true) {
                return 5;
            }
            else {
                return null;
            }
        }
    }

    public componentDidMount(): void {
        this.loadUserInfo();
    }

    public componentDidUpdate(prevProps: ISignOffFormProps): void {
        if (prevProps.formId !== this.props.formId) {
            this.loadUserInfo();
        }
    }

    private loadUserInfo = (): void => {
        if (this.props.signoffFor === "DD") {
            if (this.props.form.DDSignOffStatus === true) {
                this.userService.read(this.props.form.DDSignOffUserId).then((u: IUser): void => {
                    this.setState({ DDSignOffName: u.Title });
                }, (err) => { });
            }
            else {
                this.setState({ DDSignOffName: null });
            }

        }
        else if (this.props.signoffFor === "Dir") {
            if (this.props.form.DirSignOffStatus === true) {
                this.userService.read(this.props.form.DirSignOffUserId).then((u: IUser): void => {
                    this.setState({ DirSignOffName: u.Title });
                }, (err) => { });
            }
            else
                this.setState({ DirSignOffName: null });
        }
    }

    private validateEntityUpdate = (): boolean => {
        return true;
    }

    private displayConfirm = (): void => {
        this.setState({ ShowConfirmDialog: true });
    }

    private onAfterSave(): void {
        this.props.onSignOff();
    }

    private saveUpdate = (): void => {

        this.setState({ ShowConfirmDialog: false });
        if (this.validateEntityUpdate()) {
            let formUpdate = new CAForm();
            formUpdate.ID = this.props.form.ID;
            formUpdate.LastSignOffFor = this.props.signoffFor;

            delete formUpdate.PeriodId;
            delete formUpdate.TeamId;
            delete formUpdate.DefFormId;
            delete formUpdate.Title;
            delete formUpdate.DDSignOffStatus;
            delete formUpdate.DDSignOffUserId;
            delete formUpdate.DDSignOffDate;
            delete formUpdate.DirSignOffStatus;
            delete formUpdate.DirSignOffUserId;
            delete formUpdate.DirSignOffDate;
            delete formUpdate.FirstSignedOff;

            this.formService.update(formUpdate.ID, formUpdate).then((): void => {
                this.onAfterSave();
                if (this.props.errorHandling?.onError)
                    this.props.errorHandling?.onError(null);
                if (this.props.onSaved)
                    this.props.onSaved();
            }, (err) => {
                if (this.props.errorHandling?.onError)
                    this.props.errorHandling?.onError(`Error saving progress update`, err.message);
            });
        }
    }

    private toggleProgressUpdateForm = (): void => {
        this.setState({ ShowForm: !this.state.ShowForm });
    }
}
